import Form from 'react-bootstrap/Form';

export default function CheckboxField({
                                        name,
                                        label,
                                        type,
                                        error,
                                        fieldRef
                                      }) {
  return (
    <Form.Group controlId={name} className="CheckboxField">
      <Form.Check
        ref={fieldRef}
        type={type ? type : "checkbox"}
        id={name}
        label={label}
      />
      {error && <Form.Text className="text-danger">{error}</Form.Text>}
    </Form.Group>
  );
}
